import { gql, useMutation } from '@apollo/client';
import { PlatformsInput } from 'types/graphql-types';
import { useLoginInput } from './use-login-input';

const SAVE_PLATFORMS = gql`
  mutation SavePlatforms($platforms: PlatformsInput!) {
    savePlatforms(platforms: $platforms) {
      login
    }
  }
`;

export const useSavePlatforms = (): ((
  specialization: Omit<PlatformsInput, 'login'>,
) => Promise<void>) => {
  const loginInput = useLoginInput();
  const [saveSpecialization] = useMutation(SAVE_PLATFORMS, {
    refetchQueries: ['GetEmployee'],
  });

  return async (platforms) => {
    const opt = {
      variables: { platforms: { ...loginInput, ...platforms } },
    };

    await saveSpecialization(opt);
  };
};
